module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/_library.js
// module id = pb4Y
// module chunks = a74a